export const isAllDayDates = (start: Date, end: Date) => end.getTime() - start.getTime() == 86340000 && start.getDate() == end.getDate();